import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogLogs } from '@datadog/browser-logs';
import trackAnalyticsEvent from './helpers/trackAnalytics';

const { DATA_DOG_CLIENT_API_KEY, APP_ENV } = window.AMS_CONFIG;

interface IAnalyticsWrapperProps {
  children: React.ReactNode;
}

const AnalyticsWrapper = ({
  children,
}: IAnalyticsWrapperProps): React.ReactElement => {
  const location = useLocation();
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);

    // CREATE THE COOKIE OBJECT TO STORE
    const trackingParams: {
      url: string;
      referrer: string;
      utmSource?: string | string[];
    } = {
      url: window.location.href || document.documentURI,
      referrer: document.referrer,
    };

    if (qs.get('utm_source')) {
      trackingParams.utmSource = qs.get('utm_source') ?? '';
    }

    trackAnalyticsEvent('Visit', {
      ...trackingParams,
      nonInteraction: 1,
    });

    /* eslint-disable */
    datadogLogs.init({
      clientToken: DATA_DOG_CLIENT_API_KEY,
      datacenter: 'us',
      forwardErrorsToLogs: true,
      sampleRate: 100,
    });
    datadogLogs.setLoggerGlobalContext({ env: APP_ENV });
  }, []);

  useEffect(() => {
    const analyticsReady = Boolean(window.analytics);
    if (analyticsReady) {
      window.analytics.page(location.pathname);
    }
  }, [location]);

  return <>{children}</>;
};

export default AnalyticsWrapper;
